import React, { ReactNode } from 'react';
import classNames from 'classnames';

export interface ZenFormItemProps {
    children: ReactNode;
    className?: string;
}

const ZenFormItem: React.FC<ZenFormItemProps> = ({ children, className }) => {
    return <div className={`flex zen-form-item ${classNames(className)}`}>{children}</div>;
};

export default ZenFormItem;
